import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  buildDrillUrl,
  DashboardVersion,
  DrillDescriptor,
  WidgetFilters,
} from "../helpers/dashboardDrill";
import { useAlert } from "../context/AlertContext";

export interface UseDashboardDrillResult {
  drill: (
    descriptor: DrillDescriptor,
    widgetFilters: WidgetFilters,
    event?: { metaKey?: boolean; ctrlKey?: boolean; button?: number },
  ) => void;
  canDrill: boolean;
}

export function useDashboardDrill(
  version: DashboardVersion,
  isEditing: boolean,
): UseDashboardDrillResult {
  const navigate = useNavigate();
  const { customerId } = useParams<{ customerId: string }>();
  const showAlert = useAlert();

  const drill = useCallback<UseDashboardDrillResult["drill"]>(
    (descriptor, widgetFilters, event) => {
      if (isEditing) return;
      if (!customerId) {
        showAlert("Couldn't open search — customer not found.", "error");
        return;
      }
      const url = buildDrillUrl(customerId, version, widgetFilters, descriptor);
      const newTab =
        event?.metaKey || event?.ctrlKey || event?.button === 1;
      if (newTab) {
        window.open(url, "_blank");
        return;
      }
      navigate(url);
    },
    [customerId, isEditing, navigate, showAlert, version],
  );

  return { drill, canDrill: !isEditing };
}
